// Sidebar.js
import React, { useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import logo from "../assets/images/Auth/logo_TT_new.png";
import logoSm from "../assets/images/Header/logo-sm.png";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdCelebration } from "react-icons/md";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Collapse } from "@mui/material";
// import "../App.css"
import {
  setClientNameOptions,
  setloginUserName,
  setownerNameOptions,
  setPriorityNameOptions,
  setProjectNameOptions,
  setSeverityNameOptions,
  setStatusOptions,
  setTaskNameOptions,
  setTimesheetViewOptions,
  setUserNameOptions,
} from "../selectSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllEntities } from "../apis/apiService";
import { toast } from "react-toastify";
import milestoneImage from "../assets/images/Header/MilestoneIcon.png";
import IssueImage from "../assets/images/Header/issue image.png";
import TimesheetImage from "../assets/images/Header/Timesheet.png";
import OTSheetIcon from "../assets/images/Header/OTSheetIcon.png";
import { FaUserShield } from "react-icons/fa";
import { FaUserClock } from "react-icons/fa";
import BudgetImage from "../assets/images/Header/Budget.png";
import TaskImage from "../assets/images/Header/Task.png";
import TaskAllocationIcon from "../assets/images/tasks/TaskAllocationIcon.png";
import { BiGift } from "react-icons/bi";
import { PiCertificate } from "react-icons/pi";
import { GiRibbonMedal } from "react-icons/gi";
import SettingsImage from "../assets/images/Header/Settings Icon.png";
import DashboardImage from "../assets/images/Header/Dashboard.png";
import { RiMoneyRupeeCircleLine } from "react-icons/ri";
import { MdAssignment } from "react-icons/md";
import { Tooltip } from "@mui/material";
import { useFetchPersonalSettingsQuery } from "../slice/logdetailSlice";
import WeeklyTaskIcon from "../assets/images/Header/WeeklyTask.png";
import CRMImage from "../assets/images/Header/crm.png";
import '../App.css';
import { TbReportSearch } from "react-icons/tb";
import { style } from "@mui/system";


const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

// Reports Dropdown menu items
//===============================


//=======================================

export default function Sidebar() {
  const dispatch = useDispatch();
  const theme = useTheme();
  localStorage.getItem("project_id");
  // //console.log()("project_id", project_id);
  const { data: personal_details, isSuccess } = useFetchPersonalSettingsQuery();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = React.useState(() => {
    const stored = sessionStorage.getItem("slidebarOpen");
    // console.log("stored value :", stored);
    return stored === "true";
  });
  const [projectReportsOpen, setProjectReportsOpen] = useState(false);
  const [rewardsOpen, setRewardsOpen] = useState(false);
  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  // //console.log()("login_user_detail in redux state: ", loginUser);
  // const { name, id: login_user_id, role: login_userRole } = loginUser || {};
  const userData = Array.isArray(loginUser) ? null : loginUser;
  const { role: login_userRole } = userData || {};

  const login_user_role = login_userRole?.toUpperCase();
  React.useEffect(() => {
    // If role is not resolved yet, do not redirect
    if (!login_user_role) return;

    // Get all valid paths including sub-items
    const allValidPaths = [];
    menuItems.forEach((item) => {
      if (item.isDropdown && item.subItems) {
        item.subItems.forEach((subItem) => {
          allValidPaths.push(subItem.path);
        });
      } 
      else {
        allValidPaths.push(item.path);
      }
    });

    // Routes that exist but have no menu entry (design previews, development builds only)
    if (process.env.NODE_ENV !== "production") {
      allValidPaths.push("/utilisation-preview");
    }

    // Redirect to dashboard if no valid path is found
    if (!allValidPaths.some((path) => location.pathname.includes(path))) {
      navigate("/dashboard");
    }
  // }, [location.pathname, navigate]);
  }, [location.pathname, navigate, login_user_role]);

  // Auto-expand dropdown if any sub-item is active
  React.useEffect(() => {
    const isReportsActive =
      location.pathname.includes("Reports") ||
      location.pathname.includes("OT-Report-Sheet") ||
      location.pathname.includes("Workforce-Stability");
    if (isReportsActive) {
      setProjectReportsOpen(true);
    }

    const isRewardsActive =
      location.pathname.includes("Appraisal-Feedback") ||
      location.pathname.includes("Certificates");
    if (isRewardsActive) {
      setRewardsOpen(true);
    }
  }, [location.pathname]);

  const handleDrawerToggle = () => {
    setOpen((prevOpen) => {
      const newValue = !prevOpen;
      sessionStorage.setItem("slidebarOpen", newValue);
      return newValue;
    });
  };
  
  const isItemActive = (path) => {
    if (!path) return false;
    const cleanPath = path.replace(/^\//, "").toLowerCase();
    const currentPath = location.pathname.replace(/^\//, "").toLowerCase();
    return currentPath === cleanPath || currentPath.startsWith(`${cleanPath}/`);
  };

  // console.log(location.pathname.includes("Weekly-Task-Allocation"));
  const menuItems = [
    {
      text: "Dashboard",
      icon: (
        <img
          src={DashboardImage}
          alt="dashboard Icon"
          style={{
            width: 20,
            height: 19,
            filter: isItemActive("dashboard")
                ? "brightness(0) invert(1)" // Converts black to white
              : "none",
            transition: "filter 0.3s ease", // Smooth transition effect
          }}
        />
      ),
      path: "dashboard",
    },

    {
      text: "Projects",
      icon: (
        <MdAssignment
          fontSize="1.8rem"
          style={{
            color: location.pathname.includes("projects")
              ? "inherit"
              : "rgb(15, 163, 141)",
            transition: "color 0.3s ease",
          }}
        />
      ),
      path: "projects",
    },
    ...(login_user_role === "ADMIN" || login_user_role === "MANAGER"
      ? [
          {
            text: "Resource Earning",
            icon: (
              <RiMoneyRupeeCircleLine 
                fontSize="1.8rem"
                style={{
                  color: isItemActive("earning-dashboard")
                    ? "inherit"
                    : "rgb(15, 163, 141)",
                  transition: "color 0.3s ease",
                }}
              />
            ),
            path: "earning-dashboard",
          },
        ]
      : []),
    {
      text: "Tasks",
      icon: (
        <img
          src={TaskImage}
          alt="Task Icon"
          style={{
            width: 20,
            height: 19,
            filter: location.pathname.includes("Tasks")
                ? "brightness(0) invert(1)" // Converts black to white
              : "none",
              transition: "filter 0.3s ease", // Smooth transition effect
          }}
        />
      ),
      path: "Tasks",
    },

    // <---------------------------------------TaskAllocation---------------------------------------->

    ...(login_user_role === "ADMIN" || login_user_role === "MANAGER"
      ? [
          {
            text: "Task Allocation",
            icon: (
              <img
                src={TaskAllocationIcon}
                alt="Task allocation icon"
                style={{
                  width: 20,
                  height: 19,
                  filter: location.pathname.includes("Task-Allocation")
                      ? "brightness(0) invert(1)" // Converts black to white
                    : "none",
                    transition: "filter 0.3s ease", // Smooth transition effect
                }}
              />
            ),
            path: "Task-Allocation",
          },
        ]
      : []),

    // <---------------------------------------WeeklyTaskAllocation---------------------------------------->
    ...(login_user_role === "ADMIN" || login_user_role === "MANAGER"
      ? [
          {
            text: "Weekly Task  ",
            icon: (
              <img
                src={WeeklyTaskIcon}
                alt="Weekly  icon"
                style={{
                  width: 20,
                  height: 19,
                  filter: location.pathname.includes("Weekly-Task")
                      ? "brightness(0) invert(1)" // Converts black to white
                    : "none",
                    transition: "filter 0.3s ease", // Smooth transition effect
                }}
              />
            ),
            path: "Weekly-Task",
          },
        ]
      : []),

    // <---------------------------------------milestone---------------------------------------->
    {
      text: "Milestones",
      icon: (
        <img
          src={milestoneImage}
          alt="Milestone Icon"
          style={{
            width: 20,
            height: 19,
            filter: location.pathname.includes("Milestones")
              ? "brightness(0) invert(1)"
              : "none",
            transition: "filter 0.3s ease",
          }}
        />
      ),
      path: "Milestones",
    },

    {
      text: "Issues",
      icon: (
        <img
          src={IssueImage}
          alt="Issue Icon"
          style={{
            width: 20,
            height: 19,
            filter: location.pathname.includes("Issues")
                ? "brightness(0) invert(1)" // Converts black to white
              : "none",
              transition: "filter 0.3s ease", // Smooth transition effect
          }}
        />
      ),
      path: "Issues",
    },

    {
      text: "Timesheet",
      icon: (
        <img
          src={TimesheetImage}
          alt="Timesheet Icon"
          style={{
            width: 20,
            height: 19,
            filter: location.pathname.includes("Timesheet")
              ? "brightness(0) invert(1)"
              : "none",
            transition: "filter 0.3s ease",
          }}
        />
      ),
      path: "Timesheet",
    },

    // { text: "Calender", icon: <CalendarTodayIcon />, path: "calender" },
    ...(login_user_role === "ADMIN" || login_user_role === "MANAGER"
      ? [
          {
            text: "Reports",
            icon: <TbReportSearch size={25} />,
            isDropdown: true,
            dropdownType: "reports",
            subItems: [
              {
                text: "Project Reports",
                icon: (
                  <img
                    src={BudgetImage}
                    alt="Budget Icon"
                    style={{
                      width: 16,
                      height: 15,
                      filter: location.pathname.includes("Project-Reports")
                        ? "brightness(0) invert(1)"
                        : "none",
                      transition: "filter 0.3s ease",
                    }}
                  />
                ),
                path:"Project-Reports",
            },

              {
                text: "OT Reports",
                icon: <FaUserClock size={22} />,
                path: "OT-Report-Sheet",
              },
              
              // Workforce Stability Module
              {
                text: "Workforce Stability",
                icon: <FaUserShield size={22} />,
                path: "Workforce-Stability",
              },
              
            ],
          },
          
          {
            text: "OT Sheet",
            icon: (
              <img
                src={OTSheetIcon}
                alt="OT Sheet Icon"
                style={{
                  width: 20,
                  height: 19,
                  filter: location.pathname.includes("OT-Sheet")
                    ? "brightness(0) invert(1)"
                    : "none",
                  transition: "filter 0.3s ease",
                }}
              />
            ),
            path: "OT-Sheet",
          },
        ]
      : []),

    ...(login_user_role !== "CLIENT"
      ?[
          {
            text: "Manage Leave",
            icon: (
              <img
                src={CRMImage}
                alt="ManageLeave Icon"
                style={{
                  width: 20,
                  height: 19,
                  filter: location.pathname.includes("Manage-Leave")
                    ? "brightness(0) invert(1)"
                    : "none",
                  transition: "filter 0.3s ease",
                }}
              />
            ),
            path: "Manage-Leave",
    },]:[]),
    
    {
      text: "Holiday",
      icon: <MdCelebration size={20} />,
      path: "Holiday",
    },

    // Appraisal feedback section 
    // Comment in appraisal feedback 
    // ...(login_user_role !== "CLIENT"
    //   ?[  {
    //   text: "Appraisal Feedback",
    //   icon: (
    //     <Tooltip title="Appraisal Feedback">
    //       <GiRibbonMedal size={25}/>
    //     </Tooltip>
    //   ),
    //   path: "Appraisal-Feedback",
    // },]:[]),

    // Rewards Dropdown
    ...(login_user_role !== "CLIENT"
      ? [
          {
            text: "Rewards",
            icon: <BiGift size={22} />,
            isDropdown: true,
            dropdownType: "rewards",
            subItems: [
              {
                text: "Appraisal Feedback",
                icon: <GiRibbonMedal size={22} />,
                path: "Appraisal-Feedback",
              },
              {
                text: "Certificates",
                icon: <PiCertificate size={22} />,
                path: "Certificates",
              },
            ],
          },
        ]
      : []),

    {
      text: "Settings",
      icon: (
        <img
          src={SettingsImage}
          alt="settings Icon"
          style={{
            width: 20,
            height: 19,
            filter: location.pathname.includes("settings")
                ? "brightness(0) invert(1)" // Converts black to white
              : "none",
              transition: "filter 0.3s ease", // Smooth transition effect
          }}
        />
      ),
      path: "settings",
    },
  ];
  
  const fetchTaskNames = async () => {
    try {
      const response = await fetchAllEntities("tasksInProjects");
      // //console.log()("all task names :", response);

      dispatch(setTaskNameOptions(response?.data));
    } catch (error) {
      console.error("Error fetching tasksInProjects:", error);
    }
  };

  const fetchProjectNameList = async () => {
    try {
      const response = await fetchAllEntities("getAllProjectsDetails");
      // //console.log()(response, "ProjectNameList");
      dispatch(setProjectNameOptions(response?.data));
    } 
    catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const fetchstatusList = async () => {
    try {
      const response = await fetchAllEntities("showStatusList");
      // //console.log()(response.data.data, "showStatusList");
      dispatch(setStatusOptions(response.data));
    } 
    catch (error) {
      console.error("Error fetching showStatusList:", error);
    }
  };

  const fetchUserList = async () => {
    try {
      const response = await fetchAllEntities("userDetails");
      // //console.log()(response, "userDetails");
      dispatch(setUserNameOptions(response.data));
    } 
    catch (error) {
      console.error("Error fetching userDetails:", error);
    }
  };

  const fetchSeverityList = async () => {
    try {
      const response = await fetchAllEntities("severityDetails");
      // //console.log()(response, "severityDetails");
      dispatch(setSeverityNameOptions(response.data));
    } 
    catch (error) {
      console.error("Error fetching severityDetails:", error);
    }
  };

  // const fetchMilestonesList = async () => {
  //   try {
  //     const response = await fetchAllEntities('userDetails');
  //     // //console.log()(response, 'userDetails');
  //     dispatch(setUserNameOptions(response.data));
  //   } catch (error) {
  //     console.error('Error fetching projects:', error);
  //   }
  // };

  const fetchPriorityList = async () => {
    try {
      const response = await fetchAllEntities("priorityDetails");
      // //console.log()(response, "priorityDetails");

      dispatch(setPriorityNameOptions(response.data));
    } 
    catch (error) {
      console.error("Error fetching priorityDetails:", error);
    }
  };

  const fetchClientList = async () => {
    try {
      const response = await fetchAllEntities("clientDetails");
      // //console.log()(response, "clientDetails");
      dispatch(setClientNameOptions(response.data));
    } 
    catch (error) {
      console.error("Error fetching clientDetails:", error);
    }
  };

  const timesheetView = async () => {
    try {
      const response = await fetchAllEntities("/timesheet/getOptions");
      // //console.log()("timesheetView", response.data.columns);
      dispatch(setTimesheetViewOptions(response.data.columns));
    } 
    catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
      console.error("Error fetching timesheetView:", error);
    }
  };

  const fetchOwnerLists = async () => {
    try {
      const response = await fetchAllEntities("getManagerName");
      // //console.log()("ownerOptions", response.owner_name);
      dispatch(setownerNameOptions(response.owner_name));
    } 
    catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
      console.error("Error fetching ownerOptions:", error);
    }
  };

  // const fetchPortalUsers = async () => {
  //   try {
  //     const response = await fetchAllEntities("getAllUserDetails");
  //     // //console.log()("getAllPortalUsers", response.data);
  //     dispatch(setPortalUserNameOptions(response.data));
  //   } catch (error) {
  //     console.error("Error fetching portal users:", error);
  //   }
  // };

  // const fetchAllClients = async () => {
  //   try {
  //     const response = await fetchAllEntities("getAllClientDetails");
  //     // //console.log()("getAllClientDetails", response.data);
  //     dispatch(setPortalClients(response.data));
  //   } catch (error) {
  //     console.error("Error fetching clients:", error);
  //   }
  // };
  useEffect(() => {
    fetchProjectNameList();
    fetchstatusList();
    fetchUserList();
    fetchPriorityList();
    fetchClientList();
    timesheetView();
    // fetchAllClients();
    // fetchMilestonesList();
    // fetchPortalUsers();
    fetchOwnerLists();
    fetchTaskNames();
    fetchSeverityList();
  }, []);

  return (
    <Drawer
      variant="permanent"
      open={open}
      sx={{
        "& .MuiDrawer-paper": {
          width: open ? 240 : 60,
          boxSizing: "border-box",
          maxHeight: "100vh", // 👈 Limit to viewport height
          overflowY: "auto", // 👈 Enable vertical scroll
        },
      }}
    >
      <DrawerHeader className="p-0 justify-content-center">
        <img
          src={open ? logo : logoSm} // Show different logos based on `open` state
          alt="logo"
          style={{
            width: open ? "149px" : "30px", // Set width based on drawer open state
            // transition: 'width 0.3s ease', // Smooth transition for width change
          }}
          onClick={handleDrawerToggle}
        />

        <IconButton onClick={handleDrawerToggle} className="p-0">
          {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </DrawerHeader>
      <Divider />

      <List className="p-2">
        {menuItems.map((item) => (
          <React.Fragment key={item.text}>
            <ListItem disablePadding sx={{ display: "block" }}>
              {item.isDropdown ? (
                <>
                  <Tooltip title={!open ? item.text : ""} placement="right">
                    <ListItemButton
                    // onClick={() => setProjectReportsOpen(!projectReportsOpen)}
                      onClick={() => {
                        if (!open) {
                          setOpen(true);
                          sessionStorage.setItem("slidebarOpen", "true");
                          if (item.dropdownType === "rewards") {
                            setRewardsOpen(true);
                          } 
                          else {
                            setProjectReportsOpen(true);
                          }
                        } 
                        else {
                          if (item.dropdownType === "rewards") {
                            setRewardsOpen(!rewardsOpen);
                          } 
                          else {
                            setProjectReportsOpen(!projectReportsOpen);
                          }
                        }
                      }}
                      sx={{
                        minHeight: 58,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      // borderRadius: (location.pathname.includes("Reports") || location.pathname.includes("OT-Report-Sheet"))
                      //   ? "5px"
                      //   : "inherit",
                      // backgroundColor: (location.pathname.includes("Reports") || location.pathname.includes("OT-Report-Sheet"))
                      //   ? "rgba(2, 178, 152, 1)"
                      //   : "inherit",
                      // color: (location.pathname.includes("Reports") || location.pathname.includes("OT-Report-Sheet"))
                      //   ? "white"
                      //   : "rgba(0, 0, 0, 1)",
                        borderRadius:"inherit",
                        backgroundColor:"inherit",
                        color: "rgba(0, 0, 0, 1)",
                        "&:hover": {
                        // backgroundColor: (location.pathname.includes("Reports") || location.pathname.includes("OT-Report-Sheet"))
                        //   ? "rgba(1, 150, 130, 1)"
                        //   : "var(--hover-bg-color)",
                          backgroundColor: "var(--hover-bg-color)",
                          color: "",
                        },
                      }}
                      className="p-2 mt-1"
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        // color: (location.pathname.includes("Reports") || location.pathname.includes("OT-Report-Sheet"))
                        //   ? "white"
                        //   : "rgba(2, 178, 152, 1)",
                          color: "rgba(2, 178, 152, 1)",
                          "&:hover": {
                          // color: (location.pathname.includes("Reports") || location.pathname.includes("OT-Report-Sheet"))
                          //   ? "white"
                          //   : "rgba(1, 150, 130, 1)",
                            color: "rgba(1, 150, 130, 1)",
                          },
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.text}
                        sx={{ opacity: open ? 1 : 0 }}
                        className="fw-bold"
                      />
                      {open && (
                        <IconButton size="small" sx={{ color: "inherit" }}>
                          {item.dropdownType === "rewards"
                            ? (rewardsOpen ? <ExpandLess /> : <ExpandMore />)
                            : (projectReportsOpen ? <ExpandLess /> : <ExpandMore />)
                          }
                        </IconButton>
                      )}
                    </ListItemButton>
                  </Tooltip>
                  {/* <Collapse in={projectReportsOpen && open}  */}
                  <Collapse
                    in={
                      (item.dropdownType === "rewards" ? rewardsOpen : projectReportsOpen) && open
                    }
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {item.subItems?.map((subItem) => (
                        <ListItem key={subItem.text} disablePadding>
                          <Link to={subItem.path} style={{ textDecoration: "none", width: "100%" }}>
                            <ListItemButton
                              sx={{
                                minHeight: 48,
                                justifyContent: open ? "initial" : "center",
                                pl: open ? 4 : 2.5,
                                pr: 2.5,
                                borderRadius: isItemActive(subItem.path)
                                  ? "5px"
                                  : "inherit",
                                backgroundColor: isItemActive(subItem.path)
                                  ? "rgba(2, 178, 152, 0.8)"
                                  : "inherit",
                                color: isItemActive(subItem.path)
                                  ? "white"
                                  : "rgba(0, 0, 0, 0.8)",
                                "&:hover": {
                                  backgroundColor: isItemActive(subItem.path)
                                    ? "rgba(1, 150, 130, 0.9)"
                                    : "var(--hover-bg-color)",
                                },
                              }}
                              className="mt-1"
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 0,
                                  mr: open ? 2 : "auto",
                                  justifyContent: "center",
                                  color: isItemActive(subItem.path)
                                    ? "white"
                                    : "rgba(2, 178, 152, 0.8)",
                                }}
                              >
                                {subItem.icon}
                              </ListItemIcon>
                              <ListItemText
                                primary={subItem.text}
                                sx={{
                                  fontSize: "0.9rem",
                                  opacity: open ? 1 : 0
                                }}
                              />
                            </ListItemButton>
                          </Link>
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </>
              ) : (
                <Link to={item.path} style={{ textDecoration: "none" }}>
                  <Tooltip title={!open ? item.text : ""} placement="right">
                    <ListItemButton
                      sx={{
                        minHeight: 58,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                        borderRadius: isItemActive(item.path)
                          ? "5px"
                          : "inherit",
                        backgroundColor: isItemActive(item.path)
                          ? "rgba(2, 178, 152, 1)"
                          : "inherit",
                        color: isItemActive(item.path)
                          ? "white"
                          : "rgba(0, 0, 0, 1)",
                        "&:hover": {
                          backgroundColor: isItemActive(item.path)
                            ? "rgba(1, 150, 130, 1)"
                            : "var(--hover-bg-color)",
                          color: "",
                        },
                      }}
                      className="p-2 mt-1"
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                          color: isItemActive(item.path)
                            ? "white"
                            : "rgba(2, 178, 152, 1)",
                          "&:hover": {
                            color: isItemActive(item.path)
                              ? "white"
                              : "rgba(1, 150, 130, 1)",
                          },
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.text}
                        sx={{ opacity: open ? 1 : 0 }}
                        className="fw-bold"
                      />
                    </ListItemButton>
                  </Tooltip>
                </Link>
              )}
            </ListItem>
          </React.Fragment>
        ))}
      </List>
    </Drawer>
  );
}
// sx={{
//   minHeight: 48,
//   justifyContent: open ? 'initial' : 'center',
//   px: 2.5,
//   borderRadius:
//     location.pathname === `/${item.path}` ? '5px' : 'inherit',
//   backgroundColor:
//     location.pathname === `/${item.path}`
//       ? 'rgba(2, 178, 152, 1)'
//       : 'inherit',
//   color:
//     location.pathname === `/${item.path}`
//       ? 'white'
//       : 'rgba(0, 0, 0, 1)',
//   '&:hover': {
//     backgroundColor: 'rgba(2, 178, 152, 0.7)',
//     color: 'white',
//   },
// }}
